import { Client } from "openapi-fetch";
import { createContext } from "react";
import type { paths } from "../lib/api/schema";

type ApiContextState = Client<paths>;

export const ApiContext = createContext<ApiContextState | null>(null);

/**
 * Carries the bearer-token getter alongside the typed client so raw-`fetch`
 * callers (the SSE regen stream) can authenticate the same way the
 * openapi-fetch middleware does. Null until an {@link ApiClientProvider}
 * supplies it. See {@link useApiToken}.
 */
export const ApiTokenContext = createContext<(() => Promise<string>) | null>(
  null
);
